import { Navigate, Outlet } from "react-router-dom";
import { usePartido } from "../context/PartidoContext";

const PartidoRoute = () => {
  const { selectedPartido } = usePartido();
  const token = localStorage.getItem("jwt");
  return (selectedPartido || token) ? <Outlet /> : <Navigate to="/" replace />;
};

export default PartidoRoute;
